import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_FOOTER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				width: "100%",
				bottom: 0,
				zIndex: 3,
				position: "fixed",
				maxWidth: 445,
				background: theme.palette.common.white
			},
			rootFooter: {
				width: "100%",
				display: "flex",
				height: HEIGHT_FOOTER,
				background: theme.palette.common.white,
				boxShadow: "0px -4px 3px rgb(0 0 0 / 5%)"
			}
		}),
	{
		name: "FooterPage",
		index: 1
	}
);

export default useStyles;
